import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import Paginator from '@/components/v2/Paginator.vue';
import PhotoMixin from '@/helpers/vue_mixins/v2/PhotoMixin';
import ProductManager from '@/components/v2/ecommerce/ProductManager.vue';
import ActionButton from '@/components/action_button/Index.vue';
import Sortable from 'sortablejs';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import CopierDialog from '@/components/v2/CopierDialog.vue';
import CopierMixin from '@/helpers/vue_mixins/v2/CopierMixin';
import { ECOMMERCE_PAGINATION_OPTIONS } from '@/helpers/constants/app';
import ProductReferralMixin from '@/helpers/vue_mixins/v2/ecommerce/ProductReferralMixin';
let ProductListView = class ProductListView extends Mixins(PhotoMixin, ViewportSizeMixin, AppDetailsMixin, CopierMixin, ProductReferralMixin) {
    constructor() {
        super(...arguments);
        this.paginationLimit = 10;
    }
    paginationOptions(totalCount) {
        const index = ECOMMERCE_PAGINATION_OPTIONS.findIndex((v) => v >= totalCount) + 1;
        return index === 0
            ? ECOMMERCE_PAGINATION_OPTIONS
            : ECOMMERCE_PAGINATION_OPTIONS.slice(0, index);
    }
    get headers() {
        const headers = [
            {
                text: 'PHOTO',
                value: 'photo',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Product Name',
                value: 'product',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Description',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'FB ADS PAYLOAD',
                value: 'ads_payload',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SHARE PRODUCT LINK',
                value: 'ref_link',
                align: 'center',
                sortable: false,
            },
        ];
        if (this.productTrackable) {
            headers.push({
                text: 'SKU/Mat Code',
                value: 'skuMatCode',
                align: 'left',
                sortable: false,
            });
        }
        headers.push({
            text: 'Published',
            value: 'publish',
            align: 'left',
            sortable: false,
        }, {
            text: 'Action',
            value: 'action',
            align: 'center',
            sortable: false,
        });
        return headers;
    }
    refetchProducts() {
        this.$refs.productManager.fetchProducts();
    }
    displayPaginator(total) {
        return total > this.paginationLimit;
    }
    get pageTitle() {
        return this.$route.meta.title;
    }
    mounted() {
        const vm = this;
        vm.$nextTick(() => {
            if (vm.categoryUuid && !vm.$refs.sortableTable) {
                return;
            }
            const sortableTable = vm.$refs.sortableTable.$el.getElementsByTagName('tbody')[0];
            Sortable.create(sortableTable, {
                draggable: '.sortable-row',
                handle: '.handle',
                animation: 150,
                delay: 50,
                easing: 'cubic-bezier(1, 0, 0, 1)',
                onEnd(event) {
                    const { item, newIndex, oldIndex } = event;
                    vm.$refs.productManager.onPositionChanged(item.id, newIndex, oldIndex, event);
                },
            });
        });
    }
};
__decorate([
    Prop({ type: String, default: null })
], ProductListView.prototype, "categoryUuid", void 0);
__decorate([
    Prop({ type: String, default: null })
], ProductListView.prototype, "keyword", void 0);
ProductListView = __decorate([
    Component({
        components: {
            ActionButton,
            Draggable,
            ProductManager,
            Paginator,
            CopierDialog,
        },
    })
], ProductListView);
export default ProductListView;
